import type { Resource } from '../../';
export const product_details_addToCart_addColor: Resource = {"default":"Please Select a Color","en-gb":"Please Select a Colour"};
